import { createFileRoute } from '@tanstack/react-router';
import VerifyEmail from '@/pages/auth/verify-email';

export const Route = createFileRoute('/(auth)/verify-email')({
  component: VerifyEmail,
});